import { SkyText } from "@skypointcloud/skypoint-ui";

export function BooleanSearchHints() {
  return (
    <div className="flex flex-col gap-1 px-3 py-2 bg-gray-100 dark:bg-muted border-b border-gray-200 dark:border-border">
      <div className="flex items-center gap-1.5 flex-wrap">
        <SkyText
          size={200}
          weight="semibold"
        >
          Operators:
        </SkyText>
        <span className="text-xs font-semibold font-mono bg-white dark:bg-card border border-gray-200 dark:border-border rounded-sm px-1.5 py-px text-blue-600 dark:text-blue-400">
          AND
        </span>
        <span className="text-xs font-semibold font-mono bg-white dark:bg-card border border-gray-200 dark:border-border rounded-sm px-1.5 py-px text-blue-600 dark:text-blue-400">
          OR
        </span>
        <span className="text-xs font-semibold font-mono bg-white dark:bg-card border border-gray-200 dark:border-border rounded-sm px-1.5 py-px text-blue-600 dark:text-blue-400">
          NOT
        </span>
        <span className="text-xs font-semibold font-mono bg-white dark:bg-card border border-gray-200 dark:border-border rounded-sm px-1.5 py-px text-blue-600 dark:text-blue-400">
          "phrase"
        </span>
        <span className="text-xs font-semibold font-mono bg-white dark:bg-card border border-gray-200 dark:border-border rounded-sm px-1.5 py-px text-blue-600 dark:text-blue-400">
          ( )
        </span>
      </div>
      <span className="text-xs text-gray-400 dark:text-muted-foreground italic">
        e.g. nurse AND "full-time" NOT agency
      </span>
    </div>
  );
}
